// extracted by mini-css-extract-plugin
module.exports = {"layout":"Surveys_layout__o0YfL","content":"Surveys_content__1O9op","result":"Surveys_result___LU16","radioitems":"Surveys_radioitems__2KVap"};